export default __webpack_public_path__ + "static/media/added-watchlist.c6b2867a.svg";